/**
 * Navigates the browser to the given URL.
 */
export function navigateTo(path: string) {
    window.location.replace(path);
}